import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateNotesOpenShift", function updateNotesOpenShift(notes: string) {
    if (shiftEditorViewState().openShift) {
        shiftEditorViewState().openShift.notes = notes;
    }
});